"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carrier_1 = require("../../carrier");
const address_1 = __importDefault(require("../../address"));
const binder_1 = __importDefault(require("../../binder"));
const insuranceCoverageDescription_1 = __importDefault(require("../insuranceCoverageDescription"));
const insuranceCoverageRestrictions_1 = __importDefault(require("../insuranceCoverageRestrictions"));
const insuranceLicense_1 = __importDefault(require("../../licensing/insuranceLicense"));
class InsuranceCoverage extends insuranceCoverageDescription_1.default {
    constructor(id, name, description, policyNumber, insuranceLicenses, address, binder, limit, deductible, premium, serviceFee, serviceFeeBreakdown, tax, taxBreakdown, commission, commissionBreakdown, coverageId, coverageParameters, currency, exchangeRates, commodityExclusions, coverageCostHash, restrictions, daysBetweenPickupAndDelivery = 30, costsUSD, costsGBP, referralTrigger, metadata) {
        super(id, name, description, policyNumber);
        this.insuranceLicenses = insuranceLicenses;
        this.address = address;
        this.binder = binder;
        this.limit = limit;
        this.deductible = deductible;
        this.premium = premium;
        this.serviceFee = serviceFee;
        this.serviceFeeBreakdown = serviceFeeBreakdown;
        this.tax = tax;
        this.taxBreakdown = taxBreakdown;
        this.commission = commission;
        this.commissionBreakdown = commissionBreakdown;
        this.coverageId = coverageId;
        this.coverageParameters = coverageParameters;
        this.currency = currency;
        this.exchangeRates = exchangeRates;
        this.commodityExclusions = commodityExclusions;
        this.coverageCostHash = coverageCostHash;
        this.restrictions = restrictions;
        this.daysBetweenPickupAndDelivery = daysBetweenPickupAndDelivery;
        this.costsUSD = costsUSD;
        this.costsGBP = costsGBP;
        this.referralTrigger = referralTrigger;
        this.metadata = metadata;
    }
    static fromObj(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const insuranceLicenses = (_b = (_a = data === null || data === void 0 ? void 0 : data.insuranceLicenses) === null || _a === void 0 ? void 0 : _a.map(insuranceLicense_1.default.fromObj)) !== null && _b !== void 0 ? _b : [];
        const binder = binder_1.default.fromObj(data === null || data === void 0 ? void 0 : data.binder);
        const address = (data === null || data === void 0 ? void 0 : data.address)
            ? address_1.default.fromObj(data === null || data === void 0 ? void 0 : data.address)
            : address_1.default.empty();
        return new InsuranceCoverage(data === null || data === void 0 ? void 0 : data.id, data === null || data === void 0 ? void 0 : data.name, data === null || data === void 0 ? void 0 : data.description, data === null || data === void 0 ? void 0 : data.policyNumber, insuranceLicenses, address, binder, (_c = data === null || data === void 0 ? void 0 : data.limit) !== null && _c !== void 0 ? _c : 0, (_d = data === null || data === void 0 ? void 0 : data.deductible) !== null && _d !== void 0 ? _d : 0, (_e = data === null || data === void 0 ? void 0 : data.premium) !== null && _e !== void 0 ? _e : 0, (_f = data === null || data === void 0 ? void 0 : data.serviceFee) !== null && _f !== void 0 ? _f : 0, data === null || data === void 0 ? void 0 : data.serviceFeeBreakdown, (_g = data === null || data === void 0 ? void 0 : data.tax) !== null && _g !== void 0 ? _g : 0, data === null || data === void 0 ? void 0 : data.taxBreakdown, (_h = data === null || data === void 0 ? void 0 : data.commission) !== null && _h !== void 0 ? _h : 0, (_j = data === null || data === void 0 ? void 0 : data.commissionBreakdown) !== null && _j !== void 0 ? _j : [], (_k = data === null || data === void 0 ? void 0 : data.coverageId) !== null && _k !== void 0 ? _k : "loadsure", (_l = data === null || data === void 0 ? void 0 : data.coverageParameters) !== null && _l !== void 0 ? _l : {}, data === null || data === void 0 ? void 0 : data.currency, data === null || data === void 0 ? void 0 : data.exchangeRates, data === null || data === void 0 ? void 0 : data.commodityExclusions, data === null || data === void 0 ? void 0 : data.coverageCostHash, (data === null || data === void 0 ? void 0 : data.restrictions)
            ? insuranceCoverageRestrictions_1.default.fromObj(data === null || data === void 0 ? void 0 : data.restrictions)
            : undefined, data === null || data === void 0 ? void 0 : data.daysBetweenPickupAndDelivery, data === null || data === void 0 ? void 0 : data.costsUSD, data === null || data === void 0 ? void 0 : data.costsGBP, data === null || data === void 0 ? void 0 : data.referralTrigger, data === null || data === void 0 ? void 0 : data.metadata);
    }
    static parseTermsAndConditionsKey(keyEncoded = "{}") {
        const keyStr = Buffer.from(decodeURI(keyEncoded), "base64").toString();
        const { productId, policyNumber, binderId } = JSON.parse(keyStr);
        return { productId, policyNumber, binderId };
    }
    get termsAndConditionsFilename() {
        return `${this.name} - Terms & Conditions.pdf`;
    }
    get termsAndConditionsKey() {
        const key = {
            productId: this.id,
            policyNumber: this.policyNumber,
            binderId: this.binder.id
        };
        const keyStr = JSON.stringify(key);
        return encodeURI(Buffer.from(keyStr).toString("base64"));
    }
    get termsAndConditionsApiPath() {
        return `/insuranceCoverage/termsAndConditions/${this.termsAndConditionsFilename}?k=${this.termsAndConditionsKey}`;
    }
    get transportModes() {
        var _a, _b;
        return (_b = (_a = this.restrictions) === null || _a === void 0 ? void 0 : _a.transportModes) !== null && _b !== void 0 ? _b : [];
    }
    get isMarine() {
        return !!this.transportModes.includes(carrier_1.eTransportMode.MARINE);
    }
    get isAir() {
        return !!this.transportModes.includes(carrier_1.eTransportMode.AIR);
    }
    get isRail() {
        return !!this.transportModes.includes(carrier_1.eTransportMode.RAIL);
    }
    get isMarineOrAir() {
        return this.isMarine || this.isAir;
    }
    get isInternational() {
        var _a;
        return (_a = this.id) === null || _a === void 0 ? void 0 : _a.startsWith("ARINT");
    }
    get isLTL() {
        return this.id.includes("LTL");
    }
    get primaryTransportMode() {
        if (this.transportModes.includes(carrier_1.eTransportMode.MARINE)) {
            return carrier_1.eTransportMode.MARINE;
        }
        if (this.transportModes.includes(carrier_1.eTransportMode.AIR)) {
            return carrier_1.eTransportMode.AIR;
        }
        if (this.transportModes.includes(carrier_1.eTransportMode.PARCEL)) {
            return carrier_1.eTransportMode.PARCEL;
        }
        if (this.transportModes.includes(carrier_1.eTransportMode.ROAD)) {
            return carrier_1.eTransportMode.ROAD;
        }
        return carrier_1.eTransportMode.RAIL;
    }
    get taxesAndFees() {
        var _a, _b;
        return ((_a = this.tax) !== null && _a !== void 0 ? _a : 0) + ((_b = this.serviceFee) !== null && _b !== void 0 ? _b : 0);
    }
    get totalAmount() {
        var _a;
        return ((_a = this.premium) !== null && _a !== void 0 ? _a : 0) + this.taxesAndFees;
    }
    get taxesAndFeesInUSD() {
        var _a, _b, _c, _d;
        return ((_b = (_a = this.costsUSD) === null || _a === void 0 ? void 0 : _a.tax) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = this.costsUSD) === null || _c === void 0 ? void 0 : _c.serviceFee) !== null && _d !== void 0 ? _d : 0);
    }
    get totalAmountInUSD() {
        var _a, _b;
        return ((_b = (_a = this.costsUSD) === null || _a === void 0 ? void 0 : _a.premium) !== null && _b !== void 0 ? _b : 0) + this.taxesAndFeesInUSD;
    }
}
exports.default = InsuranceCoverage;
//# sourceMappingURL=insuranceCoverage.class.js.map